import {
  DataVersion,
  DownloadIncidentReportPayload,
  IncidentProduct,
} from '@hakimo-ui/hakimo/types';
import { useFileDownload, withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useDownloadIncidentReport(
  product: IncidentProduct,
  onSuccess?: () => void,
  onError?: (err: Error) => void,
  dataVersion?: DataVersion
) {
  const { downloadFile } = useFileDownload();
  const searchParams = new URLSearchParams({ product });
  const request = new Request(
    `/v2/orm/location_incidents/download_report?${searchParams.toString()}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    }
  );
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, DownloadIncidentReportPayload>(
    request,
    {
      onSuccess,
      onError,
      responseModifier: async (response) => {
        const blob = await response.blob();
        const fileName =
          response.headers.get('X-File-Name') || 'incident_report.pdf';
        downloadFile({ blob, fileName });
        return null;
      },
    }
  );
}

export default useDownloadIncidentReport;
